<template>
  <div
    v-if="enrollment"
    class="column rounded tournament-white elevate-3"
    style="min-height: 80px; border-left: 10px solid; overflow: hidden"
    :class="{ [border]: true, 'elevate-3d': !isJudge }"
  >
    <div class="row align-center flex pl-4">
      <!-- Team enrollmented name -->
      <div
        v-if="enrollment.entity && enrollment.entity.name"
        class="column tournament-white--text mx-2"
        style="width: 200px"
      >
        <span class="caption tournament-grey--text">Nome</span>
        <div
          class="row justify-middle subheading ellipsis-2 tournament-dark-blue--text"
          style="line-height: normal; min-height: 16px"
        >
          {{ enrollment.entity.name }}
        </div>
      </div>
      <!-- Team members count -->
      <div
        v-if="!isJudge && enrollment.team && enrollment.team.members"
        class="column tournament-white--text mx-2"
        style="width: 90px"
      >
        <span class="caption tournament-grey--text">Integrantes</span>
        <div
          class="row align-center title ellipsis tournament-dark-blue--text"
          style="line-height: normal; min-height: 16px"
        >
          {{ enrollment.team.members.length }}
        </div>
      </div>

      <!-- Enrollment status -->
      <div class="column flex tournament-white--text mx-2" style="width: 152px">
        <span
          v-if="enrollment.situation && enrollment.situation.status"
          class="caption tournament-grey--text"
        >Status</span>
        <div
          v-if="enrollment.situation && enrollment.situation.status"
          class="row align-center"
          style="line-height: normal; min-height: 16px"
        >
          <EnrollmentChip v-model="enrollment.situation.status" />
        </div>
      </div>

      <!-- More info or complete enrollment -->
      <div
        v-if="!isJudge"
        class="column align-center justify-middle tournament-light-blue--text ml-2 border-left"
        style="min-height: 80px; width: 120px"
      >
        <span>VERIFICAR</span>
      </div>
    </div>

    <!-- Enrollment Situation Notes -->
    <!-- <div
      v-if='enrollment.situation && enrollment.situation.notes'
      class="row align-center pl-4 py-2"
      style="min-height: 36px; background: #feedf0">
      <div class="row tournament-red--text">
        <div class="column mr-2">
          <v-icon color="tournament-red" style="font-size: 18px">error_outline</v-icon>
        </div>
        <b class="caption row bold mr-2 no-flex">Comentários da organização: </b>
        <div class="row caption ellipsis-1 mr-2">{{ enrollment.situation.notes }}</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import EnrollmentChip from "@/components/Enrollments/Chip";

export default {
  name: "EnrollmentTeamCard",

  components: {
    EnrollmentChip,
  },
  props: {
    enrollment: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState(["community", "isJudge"]),
    border() {
      const status = _.get(this.enrollment, "situation.status._id");
      if (!status) {
        return "tournament-grey-outline";
      }

      switch (status) {
        case "waiting":
          return "tournament-red-outline";

        case "reviewing":
          return "tournament-yellow-outline";

        case "finished":
          return "tournament-grey-outline";

        case "confirmed":
          return "tournament-green-outline";

        case "rejected":
          return "tournament-black-outline";

        case "pending_payment":
          return "tournament-yellow-outline";

        case "alternate":
          return "tournament-grey-outline";

        default:
          return "tournament-red-outline";
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Admin/Enrollment/TeamCard.vue